const { registerBlockType } = wp.blocks

import attributes from './attributes'
import Edit from './edit'
import Save from './save'

registerBlockType('app/product', {
  title: 'Produto',
  description: 'Item que compõe a sessão Fale Conosco',
  icon: 'admin-site',
  category: 'layout',
  attributes,
  supports: {
    align: ['']
  },
  edit: props => <Edit {...props} />,
  save: props => <Save {...props} />
})
